import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BACKEND_API_URL } from "../../config";

const initialState = {
  data: {
      _option: '',
      _image: null,
      shredder_option: '',
      shredder_image: null,
    }, 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const fetchInitialState = createAsyncThunk(
  'LockingCabinetDetails/fetch', 
  async (data, { getState, dispatch }) => {
      const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/locking_cabinet?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // console.log(initialState);
        return initialState;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return initialState.data
      }
    
  })



// Create New 
export const SubmitLockingCabinetDetails = createAsyncThunk(
    'LockingCabinetDetails/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
      try {
        // Add currentStep to the data
          const {token, currentStep} = getState().navigator;

          if (currentStep === 11 && data._option === '') {
              return rejectWithValue('Please select the option.');
          }

          if (currentStep === 10 && data.shredder_option === '') {
              return rejectWithValue('Please select the option.');
          }
          
          if (currentStep === 11 && data._option === 'Yes' && (!data._image || data._image === 'null')) {
              // alert("Please upload a picture of the file cabinet in your office!");
              return rejectWithValue('Please upload a picture of the file cabinet in your office!');
          }

          if (currentStep === 10 && data.shredder_option === 'Yes' && (!data.shredder_image || data.shredder_image === 'null')) {
              // alert("Please upload a picture of the file cabinet in your office!");
              return rejectWithValue('Please upload a picture of the micro cut shredder in your office!');
          }

          // because of Image, send as FormData
          const formData = new FormData();
            Object.keys(data).forEach((key) => {
              formData.append(key, data[key]);
          });

          // add current step to formData
          // formData.append('current_step', currentStep)

          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/locking_cabinet?token=${token}`, {
              method: 'POST',
              body: formData
          });
          if (!response.ok) {
            return rejectWithValue("Upload valid image file!");
          }

          const response_data =  await response.json();
          // Handle the response data
          // console.log('Form submitted successfully', response_data);
    
          return response_data.data;
          
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return rejectWithValue(error);
        }
      }
)


// Slice

export const lockingCabinetDetailsSlice = createSlice({
    name: 'LockingCabinetDetails',
    initialState,
    reducers: {
      updateLockingCabinetOption: (state, action) => {
        state.data._option = action.payload;
      },
      updateShredderOption: (state, action) => {
        state.data.shredder_option = action.payload;
      },
    },
    extraReducers: (builder) => {
        builder
          // FETCH
          // CREATE or UPDATE
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // CREATE or UPDATE
          .addCase(SubmitLockingCabinetDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitLockingCabinetDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitLockingCabinetDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { updateLockingCabinetOption, updateShredderOption } = lockingCabinetDetailsSlice.actions;

export default lockingCabinetDetailsSlice.reducer;
  